module.exports = __webpack_public_path__ + "static/media/evaluate-helpful-new.9d3f45f5.svg";